<!-- 集群管理 -->
<template>
	<div class="cluster-detail">
		<div class="view-title">
			<div class="view-title-container">
				<div class="title-left">
					<span>{{ detail.info.name }}</span>
					<span class="badge" :class="detail.info.agent ? (detail.info.agent.status === 1 ? 'available' : 'unavailable') : 'unavailable'">
						{{ detail.info.agent ? (detail.info.agent.status === 1 ? attrText.available : attrText.unavailable) : attrText.unavailable }}
					</span>
				</div>
				<div class="del-btn">
					<el-button @click="onShowConfigFile()">
						<translate>Configuration File</translate>
					</el-button>
					<el-button @click="onShowChangeName()" v-if="!detail.info.parent_id">
						<translate>Set Cluster</translate>
					</el-button>
					<el-button @click="deleteCluster()" v-if="!detail.info.parent_id">
						<translate>Delete Cluster</translate>
					</el-button>
					<el-button @click="returnCluster()" v-if="detail.info.parent_id">
						<translate>Return The Cluster</translate>
					</el-button>
				</div>
			</div>
		</div>
		<div class="ssk-wrapper">
			<el-tabs type="card" :active-name="detail.currentTab" @tab-click="onTabClick">
				<!--搜索 头部-->
				<div class="add-ssk" v-if="$route.query.type !== 'settings'">
					<span v-if="detail.currentTab === 'ecs'">
						<translate>Set The Security Mode:</translate>
						<span style="color: #58d99f">{{ $store.getters.cluster.detail.info.safe_mode ? attrText.on : attrText.off }}</span>
					</span>
					<el-button type="text" @click.stop="onShowClusterSafeMode()" class="change-btn" v-if="detail.currentTab === 'ecs'">
						<translate>Change</translate>
					</el-button>
					<el-button type="text" @click.stop="onAdd()" v-if="!detail.info.parent_id" :disabled="tableHeader.scanDis">
						<i class="fa fa-plus fa-lg"></i>
						<translate>Add</translate>
					</el-button>
					<el-button type="text" :disabled="tableHeader.scanDis" v-if="detail.currentTab === 'ecs' && !detail.info.parent_id" @click.stop="onShowClusterScanImport()">
						<i class="fa fa-television fa-lg"></i>
						<translate>Scan Import</translate>
					</el-button>
					<el-button type="text" v-if="!detail.info.parent_id" :disabled="tableHeader.scanDis" @click.stop="onShowClusterBatchInstance()">
						<i class="fa fa-list-alt fa-lg"></i>
						<translate>Mass import</translate>
					</el-button>
					<el-button type="text" v-if="!detail.info.parent_id" :disabled="tableHeader.scanDis" @click.stop="onShowClusterAkImport()">
						<i class="fa fa-cloud-upload fa-lg"></i>
						<translate>Cloud Account Import</translate>
					</el-button>
					<el-button type="text" :disabled="tableHeader.deleteIds === '' || loading" @click="batchDel(null, tableHeader.deleteIds)" v-if="!detail.info.parent_id">
						<i class="fa fa-trash fa-lg"></i>
						<translate>Delete</translate>
					</el-button>
					<div class="pull-right">
						<el-form :inline="true" class="demo-form-inline">
							<el-select v-model="tableHeader.searchForm.type" placeholder="Operating System" class="account-search" v-if="detail.currentTab === 'ecs'">
								<el-option :label="attrText.os" value=""></el-option>
								<el-option label="Linux" value="%linux%"></el-option>
								<el-option label="Windows" value="%win32%"></el-option>
							</el-select>
							<el-select v-model="tableHeader.searchForm.type" placeholder="Type" class="account-search" v-if="detail.currentTab === 'rds'">
								<el-option :label="attrText.type" value=""></el-option>
								<el-option label="MySQL" value="mysql"></el-option>
								<el-option label="SQL Server" value="mssql"></el-option>
								<el-option label="PostgreSQL" value="postgresql"></el-option>
								<el-option label="Oracle" value="oracle"></el-option>
							</el-select>
							<el-select v-model="tableHeader.searchForm.condition" placeholder="userType" class="account-search" @change="initSelect">
								<el-option :label="attrText.select" value=""></el-option>
								<el-option :label="attrText.name" value="q_name"></el-option>
								<el-option label="IP" value="q_ip"></el-option>
							</el-select>
							<el-input icon="search" v-model="tableHeader.searchForm.text" class="searchInput" @keyup.enter.native="onSearch()" :on-icon-click="onSearch" :disabled="tableHeader.searchForm.condition == ''"></el-input>
						</el-form>
					</div>
				</div>
				<!--tab 栏-->
				<el-tab-pane :label="attrText.servers" name="ecs"></el-tab-pane>
				<el-tab-pane :label="attrText.dataBase" name="rds"></el-tab-pane>
				<el-tab-pane :label="attrText.setting" name="settings">
					<!--设置可用-->
					<div class="setting-wrapper" v-if="detail.info.agent && !detail.info.parent_id">
						<div v-if="onlineConnectTooltip">
							<translate tag="p" class="font-danger"> The agent has alive users,please disconnect them to continue. </translate>
						</div>
						<div v-if="!detail.agentUpdate">
							<translate tag="p"> Please perform the following script on the control node to update the control node to the latest version </translate>
							<div class="copy-text" ref="text">
								{{ setting.available.code }}
								<el-button type="text" v-clipboard:copy="setting.available.code" v-clipboard:success="copySuccess">
									<translate>Copy</translate>
								</el-button>
							</div>
						</div>
						<translate tag="p" v-if="detail.agentUpdate && !detail.backAgent" style="margin-bottom: 10px"> The network has successfully installed the agent. If you need to change, please click "Uninstall Agent". </translate>
						<div v-if="detail.backAgent">
							<translate tag="p"> Please perform the following script on the control node to roll back the management node </translate>
							<div class="copy-text" ref="text">
								{{ setting.backAgentCode }}
								<el-button type="text" v-clipboard:copy="setting.backAgentCode" v-clipboard:success="copySuccess">
									<translate>Copy</translate>
								</el-button>
							</div>
						</div>
						<p class="general">
							<translate class="m-space bold">General Situation</translate>
							<span class="m-space"><translate class="m-space">Control node IP:</translate> {{ detail.info.agent.host }}</span>
							<span class="m-space"><translate class="m-space">Control node version:</translate> {{ detail.info.agent ? detail.info.agent.version : '' }}</span>
						</p>
						<div class="agent-wrapper">
							<!--test old agent-->
							<el-button @click="updateAgent()">
								<translate>Agent Update</translate>
							</el-button>
							<el-button @click="backAgent()">
								<translate>Back Agent</translate>
							</el-button>
							<el-button @click="unBindAgent()">
								<translate>Uninstall Agent</translate>
							</el-button>

							<!--
                old agent
                new agent
                limit
                -->
							<!--<el-tooltip class="item" effect="dark" :content="attrText.notSupport" placement="top" v-if="detail.info.version < '3.0.0'">-->
							<!--<el-button class="disable-btn">-->
							<!--<translate>Agent Update</translate>-->
							<!--</el-button>-->
							<!--</el-tooltip>-->
							<!--<el-tooltip class="item" effect="dark" :content="attrText.notSupport" placement="top" v-if="detail.info.version < '3.0.0'">-->
							<!--<el-button class="disable-btn">-->
							<!--<translate>Uninstall Agent</translate>-->
							<!--</el-button>-->
							<!--</el-tooltip>-->
							<!--<el-button @click="updateAgent()" v-if="detail.info.version >= '3.0.0'">-->
							<!--<translate>Agent Update</translate>-->
							<!--</el-button>-->
							<!--<el-button @click="unBindAgent()" v-if="detail.info.version >= '3.0.0'">-->
							<!--<translate>Uninstall Agent</translate>-->
							<!--</el-button>-->
						</div>
					</div>
					<!--设置不可用-->
					<div>
						<div class="setting-unavailable" v-if="!detail.info.agent && !detail.info.parent_id">
							<!-- 注销阿里云key -->
							<!-- <div class="unavailable-form" v-if="detail.info.agent === null">
                <el-checkbox v-model="setting.unavailable.check" :disabled="setting.unavailable.disCheck">
                  <translate>
                    Integration of third party AK can increase the resource management related operations. (CloudLinker never retain the user's AK, the information will be stored in the user's own control node.)
                  </translate>
                </el-checkbox>
                <el-form :model="unavailableForm" :rules="rules" ref="unavailableForm" label-width="160px"
                         style="margin-top: 10px" v-show="setting.unavailable.check && !setting.unavailable.disCheck">
                  <el-form-item :label="attrText.cloudName" prop="name">
                    <div class="unavailable-select">
                      <el-select v-model="unavailableForm.name">
                        <el-option :label="attrText.aliyun" value="aliy"></el-option>
                      </el-select>
                    </div>
                    <p class="tip-text">
                      <translate>
                        It is recommended to use the RAM sub-account and authorize the management of the resources added in the cluster
                      </translate>
                    </p>
                  </el-form-item>
                  <el-form-item label="Access Key Id" prop="keyId">
                    <div class="unavailable-select">
                      <el-input type="tel" v-model="unavailableForm.keyId"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="Access Key Secret" prop="keySecret">
                    <div class="unavailable-select">
                      <el-input v-model="unavailableForm.keySecret"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item :label="attrText.region" prop="region">
                    <div class="unavailable-select">
                      <el-select v-model="unavailableForm.region" :placeholder="attrText.select">
                        <el-option v-for="(item, index) in setting.unavailable.regionList"
                                   :label="$gettext(item.localName)"
                                   :value="item.regionId" :key="index"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-button type="primary" @click="onSubmitUnableForm()" :disabled='!unavailableForm.isCanSubmit'
                             class="set-btn">
                    <translate>Save</translate>
                  </el-button>
                </el-form>
                <p class="unable-tip" v-if="setting.unavailable.disCheck">
                  <translate>
                    The execution script has been updated, please copy the following latest script to execute.
                  </translate>
                </p>
              </div> -->
							<div class="setting-wrapper" v-if="setting.unavailable.code !== ''">
								<p>
									<translate> Please execute the following script on a server in the current cluster (recommended using CentOS 7.9, 64 Bit) to configure the machine as a managed node.</translate>
								</p>
								<el-row class="copy-text">
									<el-col :span="22">
										<p class="code">{{ setting.unavailable.code }}</p>
									</el-col>
									<el-col :span="2">
										<el-button type="text" v-clipboard:copy="setting.unavailable.code" v-clipboard:success="copySuccess">
											<translate>Copy</translate>
										</el-button>
									</el-col>
								</el-row>
								<div class="tips">
									<p>
										<translate>Notes for Attention:</translate>
									</p>
									<p>
										<translate> 1) Network recommends configuration 2 cores 4G,40GB disk,10Mbps network bandwidth.(Recommended configuration:4 cores,4G,40GB disk,20Mbps or higher network bandwidth)</translate>
									</p>
									<p>
										<translate> 2) To ensure the normal operation of the control node functions, the remaining disk space must be greater than 5GB.</translate>
									</p>
									<p>
										<translate> 3) After executing the installation script, CloudLinker will use the public IP of your host as the control node IP. If there are any special requirements, please replace "default" with the IP or domain name you want to specify. If you need to modify the connection port of the control node, replace the default port number with the new one.</translate>
									</p>
									<p>
										<translate> 4) In consideration of the system performance, it is recommended that the server of agent don’t be used for other purposes. </translate>
									</p>
									<p>
										<translate>5) Make sure that wget and curl are installed on your server.</translate>
									</p>
									<p>
										<translate>6) Other:</translate>
										<a href="https://mrdoc.cloudcare.cn/doc/278/" target="_blank">
											<translate>Control Node Function Description Document</translate>
										</a>
									</p>
								</div>
								<p class="general">
									<translate class="m-space bold">General Situation</translate>
									<span class="m-space"><translate class="m-space">Control node IP:</translate> <translate>No time</translate></span>
									<span class="m-space"><translate class="m-space">Control node version:</translate> <translate>No time</translate></span>
								</p>
							</div>
						</div>
						<el-tabs class="setting-tab" v-model="setting.activeTab" :active-name="setting.settingActivetab" @tab-click="onSettingTabClick">
							<div class="setting-header" v-if="!detail.info.parent_id">
								<el-button type="text" @click.stop="onSettingAdd">
									<i class="fa fa-plus fa-lg"></i>
									<translate>Add</translate>
								</el-button>
								<el-button type="text" v-if="setting.activeTab === 'logFilter'" :disabled="this.setting.logBatchIds === ''" @click="batchDelLogFilter()">
									<i class="fa fa-trash fa-lg"></i>
									<translate>Delete</translate>
								</el-button>
							</div>
							<!-- share cluster tab-->
							<el-tab-pane :label="attrText.shareCluster" name="shareCluster" v-if="!detail.info.parent_id">
								<el-table :data="setting.shareList" style="width: 100%" :row-class-name="tableRowClassName">
									<el-table-column :label="attrText.teamId">
										<template scope="scope">
											{{ scope.row.company.domain }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.teamName">
										<template scope="scope">
											{{ scope.row.company.full_name }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.shareTime">
										<template scope="scope">
											{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.action" width="120">
										<template scope="scope">
											<el-button type="text" @click="delShareCluster(scope.row.id)">
												<translate>Cancel Share</translate>
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
							<!--log filter tab-->
							<el-tab-pane :label="attrText.logFilter" name="logFilter">
								<el-table :data="setting.logList" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectLog" v-if="detail.info && setting.settingActivetab === 'logFilter'">
									<el-table-column v-if="!detail.info.parent_id" type="selection" width="30"></el-table-column>
									<el-table-column :label="attrText.filtersOperation">
										<template scope="scope">
											{{ scope.row.operator }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.condition">
										<template scope="scope">
											{{ scope.row.condition }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.createTime">
										<template scope="scope">
											{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.action" width="100" v-if="!detail.info.parent_id">
										<template scope="scope">
											<el-button type="text" @click="delLogFilter(scope.row.id)">
												<translate>Delete</translate>
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
						</el-tabs>
					</div>
				</el-tab-pane>
			</el-tabs>
			<!--主机和数据库的列表-->
			<div class="table-wrapper" v-loading="loading" v-if="detail.info && $route.query.type !== 'settings'">
				<el-table :data="detail.list" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange" v-if="detail.list && detail.currentTab !== 'settings'">
					<el-table-column type="selection" width="30"></el-table-column>
					<el-table-column :label="attrText.name" width="220">
						<template scope="scope">
							<el-tooltip placement="top" :content="scope.row.name">
								<p class="truncate">{{ scope.row.name }}</p>
							</el-tooltip>
							<!--注释云标志-->
							<!--<span v-if="detail.info.agent && detail.info.agent.iaas_platform && scope.row.instance_id"-->
							<!--class="open-key"-->
							<!--@click="onCloudShow({resourceId: scope.row.id, instanceId: scope.row.instance_id})">-->
							<!--<i class="fa fa-cloud open-key"-->
							<!--v-if="detail.info.agent && detail.info.agent.iaas_platform && scope.row.instance_id"></i>-->
							<!--{{scope.row.name}}-->
							<!--</span>-->
							<el-tooltip class="item" effect="dark" :content="attrText.needPsw" placement="top" v-if="scope.row.resource_status === 2">
								<i class="fa fa-warning text-warning"></i>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.accountName">
						<template scope="scope">
							<p v-for="item in scope.row.login_type">
								<span>{{ item.username }}</span>
								<el-tooltip class="item" effect="dark" :content="attrText.cos" placement="top" v-if="item.csos_check === 'open'">
									<i class="fa fa-expeditedssl"></i>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" :content="scope.row.type == 'WinServer' ? attrText.passwordFree : attrText.targetKey" placement="top" v-if="item.autologin">
									<i class="fa fa-unlock-alt"></i>
								</el-tooltip>
							</p>
						</template>
					</el-table-column>
					<el-table-column :label="detail.currentTab === 'ecs' ? 'IP' : attrText.dataBaseName">
						<template scope="scope">
							<p v-if="detail.currentTab === 'ecs'">{{ scope.row.ip }}</p>
							<div v-else>
								<p v-for="item in scope.row.db_name">{{ item }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="detail.currentTab === 'ecs' ? attrText.os : attrText.innerIp" width="220">
						<template scope="scope">
							<div v-if="detail.currentTab === 'ecs'">{{ scope.row.type === 'WinServer' ? 'Windows' : 'Linux' }}</div>
							<div v-else>
								<el-tooltip placement="top" :content="scope.row.ip">
									<p class="truncate">{{ scope.row.ip }}</p>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>

					<el-table-column :label="detail.currentTab === 'ecs' ? attrText.specification : attrText.type">
						<template scope="scope">
							<span v-if="detail.currentTab === 'ecs'">{{ scope.row.flavor ? scope.row.flavor : '-' }}</span>
							<div v-else>
								<span v-if="scope.row.type === 'SQLServerDatabase'">SQL Server</span>
								<span v-else-if="scope.row.type === 'PostgreSQLDatabase'">PostgreSQL</span>
								<span v-else-if="scope.row.type === 'OracleDatabase'">Oracle</span>
								<span v-else>MySQL</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.Connectivity">
						<template scope="scope">
							<el-button type="text" :disabled="scope.row.test_result === 'pending' || (detail.info.agent ? detail.info.agent.status !== 1 : !detail.info.agent)" @click="onTestConnection(scope.row)">
								<translate>Test</translate>
							</el-button>
							<i class="el-icon-loading" v-if="scope.row.test_result === 'pending'"></i>
							<span v-if="scope.row.test_result === 'disable' || scope.row.test_result === 'enable'" class="badge" :class="scope.row.test_result && scope.row.test_result === 'disable' ? 'unavailable' : 'available'">{{ scope.row.test_result && scope.row.test_result === 'disable' ? attrText.no : attrText.yes }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.action" width="180">
						<template scope="scope">
							<el-button type="text" @click.stop="onSetting(scope.row.id)">
								<translate>Setting</translate>
							</el-button>
							<el-button type="text" :loading="scope.row.deleting" @click="batchDel(scope.row, [scope.row.id])" v-if="!detail.info.parent_id">
								<translate v-if="!scope.row.deleting">Delete</translate>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination" v-if="detail.totalPage > 10">
					<el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
				</div>
			</div>
		</div>

		<!--上传dialog-->
		<el-dialog :title="attrText.upload" :visible.sync="upload.isUpload" class="dialog">
			<div class="dialog-content">
				<el-form>
					<el-form-item :label="attrText.password"
						>:
						<el-input v-model="upload.password" type="password"></el-input>
						<translate tag="p">(The password of %{upload.username} for the destination host)</translate>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onComfirmUpload()" :disabled="upload.password === ''">
					<span v-if="upload.status !== 'pending'"><translate>Upload</translate></span>
					<span v-if="upload.status === 'pending'"><translate>Uploading</translate> <i class="el-icon-loading"></i></span>
				</el-button>
				<el-button @click="upload.isUpload = false">
					<translate>Close</translate>
				</el-button>
			</div>
		</el-dialog>
		<!--start-->
		<el-dialog :title="attrText.turnInstance" :visible.sync="cluodDialog.start" size="tiny">
			<translate>Are you sure to Turn On Instance?</translate>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onStart"><translate>Ok</translate></el-button>
				<el-button @click="cluodDialog.start = false"><translate>Cancel</translate></el-button>
			</span>
		</el-dialog>

		<!-- restart-->
		<el-dialog :title="attrText.reStartText" :visible.sync="cluodDialog.reStart" class="instance-dialog" @open="onOpenRestart" @click.stop="testOpen()">
			<div class="dialog-content">
				<translate tag="p" class="tip">Are you sure to start 1 instances?</translate>
				<p class="instance-id">{{ cluodDialog.Instances.InstanceId }}</p>
				<el-row>
					<el-col :span="5">
						<translate>The Way Of Start:</translate>
					</el-col>
					<el-col :span="19">
						<el-radio class="radio" v-model="cluodDialog.reStartWay" label="1">
							<translate>Reboot</translate>
						</el-radio>
						<el-radio class="radio" v-model="cluodDialog.reStartWay" label="2">
							<translate>Forced Restart</translate>
						</el-radio>
					</el-col>
				</el-row>
				<div class="force-stop" v-if="cluodDialog.reStartWay === '2'">
					<translate tag="p" class="tip"> The forced restart server will causes the virtual host to lose data that is not currently saved. </translate>
					<el-checkbox v-model="cluodDialog.isForcereStart">
						<translate>Make Sure To Restart</translate>
					</el-checkbox>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="info" @click="onRestart" :disabled="cluodDialog.reStartWay === '2' && !cluodDialog.isForcereStart">
					<translate>Ok</translate>
				</el-button>
				<el-button @click="cluodDialog.reStart = false">
					<translate>Close</translate>
				</el-button>
			</div>
		</el-dialog>

		<!-- stop-->
		<el-dialog :title="attrText.stopInstanceText" :visible.sync="cluodDialog.stopInstance" class="instance-dialog" @open="onOpenStop" @click.stop="testOpen()">
			<div class="dialog-content">
				<translate tag="p" class="tip">Are you sure to stop 1 instances?</translate>
				<p class="instance-id">{{ cluodDialog.Instances.InstanceId }}</p>
				<el-row>
					<el-col :span="5">
						<translate>The Way Of Stop:</translate>
					</el-col>
					<el-col :span="19">
						<el-radio class="radio" v-model="cluodDialog.stopWay" label="1">
							<translate>Stop</translate>
						</el-radio>
						<el-radio class="radio" v-model="cluodDialog.stopWay" label="2">
							<translate>Forced To Stop</translate>
						</el-radio>
					</el-col>
				</el-row>
				<div class="force-stop" v-if="cluodDialog.stopWay === '2'">
					<translate tag="p" class="tip"> The forced stop server will causes the virtual host to lose data that is not currently saved. </translate>
					<el-checkbox v-model="cluodDialog.isForceShop">
						<translate>Make Sure To Stop</translate>
					</el-checkbox>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="info" @click="onStop" :disabled="cluodDialog.stopWay === '2' && !cluodDialog.isForceShop">
					<translate>Ok</translate>
				</el-button>
				<el-button @click="cluodDialog.stopInstance = false">
					<translate>Close</translate>
				</el-button>
			</div>
		</el-dialog>
		<!--更新提示-->
		<el-dialog :title="attrText.updateTip" :visible.sync="detail.updateTip" class="instance-dialog" @close="closeUpdateTip()">
			<div class="dialog-content">
				<p style="text-align: center">
					<translate tag="span">The control node agent has released a new version, please update,</translate>
					<translate tag="span">can click</translate>
					<a href="https://mrdoc.cloudcare.cn/doc/318/"> <translate tag="span">update log</translate> </a>
					<translate tag="span">for detail.</translate>
				</p>

				<div class="agent-compile">
					<p class="agent-version">
						<translate class="sub-title">Current Version:</translate>
						<span class="version">{{ detail.info.agent ? detail.info.agent.version : '' }}</span>
					</p>
					<p class="agent-version">
						<translate class="sub-title">New Version:</translate>
						<span class="version">{{ newAgentVersion }}</span>
					</p>
				</div>
				<p style="text-align: center; color: #fda541; margin-top: 30px" v-if="detail.info.agent && detail.info.agent.version && detail.info.agent.version.split('-')[0].split('.')[0] === '2'">
					<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
					<translate>Version 2.0 upgrade to Version 3.0 will disable the old connection code, please be prepared</translate>
				</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="info" @click="updateAgent">
					<translate>Update Now</translate>
				</el-button>
				<el-button @click="closeUpdateTip()">
					<translate>Remind Me Later</translate>
				</el-button>
			</div>
		</el-dialog>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="callback" @upload="onUpload" @onShowCloudDialog="onShowCloudDialog" ref="rightComponent"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import { Utils, baseUrl, ClusterRegionConfig } from '../../config'
import ClusterSafeMode from './model/cluster-safe-mode'
import ChangeCluster from './model/cluster-change-name.vue'
import ClusterAddInstance from './model/cluster-add-instance'
import ClusterBatchInstance from './model/cluster-batch-instances'
import ClusterScanImport from './model/cluster-scan-import'
import ClusterAkImport from './model/cluster-ak-import'
import ClusterInstanceSetting from './model/cluster-instance-setting'
import ClusterAddDatabase from './model/cluster-add-database'
import ClusterDatabaseSetting from './model/cluster-database-setting'
import ClusterAddShare from './model/cluster-add-share'
import ClusterLogFilter from './model/cluster-log-filter'
import ClusterCheckSupport from './model/cluster-check-support'
import ClusterCloudAk from './model/cluster-cloud-ak'
import ClusterConfigFile from './model/cluster-config-file.vue'
import SetCluster from './model/cluster-set'
import ElButton from '../../../node_modules/element-ui/packages/button/src/button'
import Utility from '../../Utils'
export default {
	data() {
		return {
			loading: false,
			currentRightPanel: null,
			rightPanelData: null,
			newAgentVersion: '',
			refresh: [],
			supportMutipleDatabase: false,
			detail: {
				updateTip: false,
				currentTab: 'ecs',
				info: {},
				list: [],
				totalPage: 0,
				currentPage: 1,
				taskId: '',
				isTest: [],
				agentUpdate: true,
				backAgent: false,
			},
			tableHeader: {
				scanDis: false,
				deleteIds: '',
				searchForm: {
					type: '',
					condition: '',
					text: '',
				},
				filters: [],
			},
			setting: {
				activeTab: '',
				settingActivetab: 'shareCluster',
				shareList: [],
				logList: [],
				logBatchIds: '',
				available: {
					code: '',
				},
				backAgentCode: '',
				unavailable: {
					check: false,
					disCheck: false,
					code: '',
					regionList: ClusterRegionConfig,
				},
				isUpdateCode: false,
				agent_sha: '',
			},
			unavailableForm: {
				name: 'aliy',
				keyId: '',
				keySecret: '',
				region: '',
				isCanSubmit: false,
			},
			upload: {
				isUpload: false,
				resourceId: '',
				username: '',
				password: '',
				status: '',
			},
			cloud: {
				show: false,
				basicInfo: {},
				regions: null,
				zones: null,
				Memory: null,
				RegionName: '',
				ZoneName: '',
				systemDisk: '',
				dataDisk: '',
			},
			cluodDialog: {
				stopInstance: false,
				reStart: false,
				start: false,
				Instances: {},
				resourceId: '',
				stopWay: '1',
				isForceShop: false,
				reStartWay: '1',
				isForcereStart: false,
			},
			Instances: null,
			rules: {
				name: [{ required: true, message: this.$gettext('Please select the name'), trigger: 'change' }],
				keyId: [{ required: true, message: this.$gettext('Please input the key ID'), trigger: 'change' }],
				keySecret: [{ required: true, message: this.$gettext('Please input the key secret'), trigger: 'change' }],
				region: [{ required: true, message: this.$gettext('Please select the region'), trigger: 'change' }],
			},
			intervalId: null,
			onlineConnectTooltip: false,
			currentConnectList: [],
		}
	},
	computed: {
		attrText() {
			return this.getAttrText()
		},
		// currentConnectList () {
		//   console.log('currentConnectList', this.$store.getters.dashboard.onlineMembers)
		//   return this.$store.getters.dashboard.onlineMembers
		// },
		currentAccount() {
			return this.$store.getters.account
		},
	},
	created() {
		this.getNewAgentVersion()
		// this.intervalId = setInterval(() => {
		//   this.getDetailInfo()
		// }, 60000)
		this.detail.currentTab = this.$route.query.type
		// this.$router.push({name: 'clusterDetail', query: {type: this.detail.currentTab}})
	},
	methods: {
		// 获取翻译文本
		getAttrText() {
			return {
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				on: this.$gettext('On'),
				off: this.$gettext('Off'),
				yes: this.$gettext('yes'),
				no: this.$gettext('no'),
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('Databases'),
				setting: this.$gettext('Setting'),
				shareCluster: this.$gettext('Share Cluster'),
				logFilter: this.$gettext('Log Filter'),
				name: this.$gettext('Name'),
				accountName: this.$gettext('Account Name'),
				dataBaseName: this.$gettext('Database Name'),
				os: this.$gettext('OS'),
				specification: this.$gettext('Specification'),
				type: this.$gettext('Type'),
				Connectivity: this.$gettext('Connectivity'),
				action: this.$gettext('Action'),
				opSystem: this.$gettext('Operating System'),
				region: this.$gettext('region'),
				select: this.$gettext('select'),
				cloudName: this.$gettext('Cloud Name'),
				teamId: this.$gettext('Team Id'),
				teamName: this.$gettext('Team Full Name'),
				shareTime: this.$gettext('Sharing Time'),
				filtersOperation: this.$gettext('Filters Operation'),
				condition: this.$gettext('Condition'),
				createTime: this.$gettext('Create Time'),
				upload: this.$gettext('Upload'),
				password: this.$gettext('Password'),
				targetKey: this.$gettext('ssh key verification'),
				passwordFree: this.$gettext('Password Free Authentication'),
				cos: this.$gettext('CloudLinker Authority Authentication'),
				aliyun: this.$gettext('aliyun'),
				stopInstanceText: this.$gettext('Stop The Instance'),
				reStartText: this.$gettext('Reboot Instance'),
				needPsw: this.$gettext('Need to re input database password'),
				turnInstance: this.$gettext('Turn On Instance'),
				notSupport: this.$gettext('Not available now,coming soon.'),
				updateTip: this.$gettext('Update Tip'),
				innerIp: this.$gettext('IP/Connection Address'),
				desDocument: this.$gettext('Control Node Function Description Document'),
			}
		},
		initSelect(val) {
			if (!val) {
				this.tableHeader.searchForm.text = ''
			}
		},
		// 获取最新的agent版本
		getNewAgentVersion() {
			this.$store.dispatch(STORE_CONST.CLUSTER.CHECK_AGENT).then((res) => {
				this.newAgentVersion = res.version
				this.refresh = res.refresh
				this.setting.agent_sha = res.agent_sha
				this.getDetailInfo()
			})
		},

		// 配置文件
		onShowConfigFile() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterConfigFile' ? 0 : 300
			this.currentRightPanel = ClusterConfigFile
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						info: this.detail.info,
						callback: this.updateDetailInfo,
					}
				}, time)
			})
		},
		// 修改集群名称
		onShowChangeName() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'SetCluster' ? 0 : 300
			this.currentRightPanel = SetCluster
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						info: this.detail.info,
					}
				}, time)
			})
		},
		// 获取一集群详情
		getDetailInfo() {
			let params = Number(this.$route.params.id)
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_DETAIL, params).then((res) => {
				console.log('%c集群详情', 'color:red', res)
				if (res.agent) {
					if (res.agent.features) {
						var features = JSON.parse(res.agent.features)
						this.supportMutipleDatabase = features.indexOf('support-multiple-databases') > 0
					}
					res.version = Utility.Utils.getAgentVersion(res.agent.version)
					console.log(new Date(new Date().setHours(0, 0, 0, 0) + 86400000), new Date().getTime())
					// 过期时间  当天24:00
					let expiresTime = new Date().setHours(0, 0, 0, 0) + 86400000
					let agentUpdateTip = localStorage.getItem('agentUpdateTip')
					let oldVersion = Utility.Utils.getAgentVersion(res.agent.version) // 旧版本
					let newVersion = Utility.Utils.getAgentVersion(this.newAgentVersion) // 新版本
					let isNeedUndateVersion = Utility.Utils.isNeedUpdate(res.agent.version, this.newAgentVersion) // 是否需要更新
					if (isNeedUndateVersion && !res.parent_id) {
						if (!agentUpdateTip) {
							this.detail.updateTip = true
							// 99
							let clusterArr = []
							clusterArr.push({
								accountId: this.currentAccount.id,
								resource: [{ id: params, expiresTime: expiresTime }],
							})
							localStorage.setItem('agentUpdateTip', JSON.stringify(clusterArr))
						} else {
							console.log(JSON.parse(agentUpdateTip))
							let tipList = JSON.parse(agentUpdateTip)
							let accountIDs = tipList.map((item) => {
								return item.accountId
							})
							// 判断是否又该用户
							if (accountIDs.indexOf(this.currentAccount.id) > -1) {
								for (let i = 0; i < tipList.length; i++) {
									console.log(tipList[i].accountId, this.currentAccount.id)
									if (tipList[i].accountId === this.currentAccount.id) {
										let ids = tipList[i].resource.map((item) => {
											return item.id
										})
										// 判断是否有该资源
										if (ids.indexOf(params) > -1) {
											tipList[i].resource.forEach((item) => {
												if (item.id === params) {
													// 判断时间有没有过期
													if (item.expiresTime < new Date().getTime()) {
														this.detail.updateTip = true
														item.expiresTime = expiresTime
														localStorage.setItem('agentUpdateTip', JSON.stringify(tipList))
													}
												}
											})
										} else {
											this.detail.updateTip = true
											tipList[i].resource.push({ id: params, expiresTime: expiresTime })
											localStorage.setItem('agentUpdateTip', JSON.stringify(tipList))
										}
										break
									}
								}
							} else {
								this.detail.updateTip = true
								tipList.push({
									accountId: this.currentAccount.id,
									resource: [{ id: params, expiresTime: expiresTime }],
								})
								localStorage.setItem('agentUpdateTip', JSON.stringify(tipList))
							}
						}
					}
				}
				this.detail.info = res
				this.detail.info.agent ? (this.detail.info.agent.status === 1 ? (this.tableHeader.scanDis = false) : (this.tableHeader.scanDis = true)) : (this.tableHeader.scanDis = true)
				// 设置中的
				this.setting.logList = res.log_filters
				if (res.parent_id) {
					this.setting.settingActivetab = 'logFilter'
				}
				if (!this.setting.isUpdateCode) {
					// this.setting.unavailable.code = 'EXPECT=' + this.setting.agent_sha + ';tmp=$(mktemp) && curl -fsSL ' + baseUrl.agentInstallUrl + ')" - --key ' + this.detail.info.key + ' --sshproxyport 9998 --websshport 8889 --mysqlproxyport 9696 --mssqlproxyport 9433 --postgresqlproxyport 9432 --rdpagentport 9389 --webrdpagentport 8389 --guacdport 4822 --self-host default'
					this.setting.unavailable.code = `bash -c "$(curl -fsSL ${baseUrl.agentInstallUrl})" - --key ${this.detail.info.key} --sshproxyport 9998 --websshport 8889 --mysqlproxyport 9696 --mssqlproxyport 9433 --postgresqlproxyport 9432 --oracleproxyport 9521 --rdpagentport 9389 --webrdpagentport 8389 --guacdport 4822 --self-host default`
					// this.setting.available.code = 'bash -c "$(curl -fsSL ' + baseUrl.agentInstallUrl + ')"' + ' - --upgrade 1' + ' --csos-host ' + baseUrl.csosHost
					this.setting.available.code = `bash -c "$(curl -fsSL ${baseUrl.agentInstallUrl})" - --upgrade 1 --csos-host ${baseUrl.csosHost}`
				}
				this.changeCurrentTab(this.$route.query.type, res.default_project_id)
			})
		},
		// 更新集群详情
		updateDetailInfo() {
			let params = Number(this.$route.params.id)
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_DETAIL, params).then((res) => {
				console.log('%c集群详情', 'color:red', res)
				this.detail.info = res
			})
		},
		// 获取资源列表
		getDetailList(page, defaultProjectId) {
			this.loading = true
			this.detail.currentPage = page || 1
			let params = {
				id: defaultProjectId || this.detail.info.default_project_id,
				params: {
					page: page || 1,
					type: this.$route.query.type,
				},
			}
			if (this.tableHeader.searchForm.type !== '') {
				params.params.q_os = this.tableHeader.searchForm.type
			}
			if (this.tableHeader.searchForm.text !== '') {
				params.params[this.tableHeader.searchForm.condition] = this.tableHeader.searchForm.text
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then((res) => {
				console.log(res, 'res')
				this.loading = false
				this.detail.list = res.objects
				this.detail.totalPage = res.total
			})
		},
		// 删除集群
		deleteCluster() {
			this.$confirm(this.$gettext('Are you sure to delete this Cluster?'), this.$gettext('Delete Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.CLUSTER.DELETE, this.$route.params.id).then(() => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Delete successfully!'),
					})
					this.$router.push('/settings/cluster')
				})
			})
		},
		// 退回集群
		returnCluster() {
			this.$confirm(this.$gettext('Return the current cluster?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.CLUSTER.DELETE, this.$route.params.id).then(() => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Return successfully!'),
					})
					this.$router.push('/settings/cluster')
				})
			})
		},
		// delete recource
		batchDel(row, ids) {
			this.$confirm(this.$gettext('Are you sure to delete this resouce?'), this.$gettext('Delete Resource Comfirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					row && this.$set(row, 'deleting', true)
					!row && (this.loading = true)
					let params = {
						projectId: this.detail.info.default_project_id,
						data: {
							resources: ids,
						},
					}
					this.$store
						.dispatch(STORE_CONST.WORKGROUP.DEL_WORKGROUP_RESOURCE, params)
						.then(() => {
							this.$notify({
								type: 'success',
								message: this.$gettext('Delete successfully!'),
							})
							this.getDetailList(this.detail.currentPage, this.detail.info.default_project_id)
						})
						.finally(() => {
							row && this.$set(row, 'deleting', false)
							!row && (this.loading = true)
						})
				})
				.catch(() => {
					row && this.$set(row, 'deleting', false)
					!row && (this.loading = true)
				})
		},
		// selection delete resource
		onSelectionChange(val) {
			if (val.length === 0) {
				this.tableHeader.deleteDisabled = true
				this.tableHeader.deleteIds = ''
			} else {
				this.tableHeader.deleteDisabled = false
				let idArr = []
				idArr = val.map('id')
				this.tableHeader.deleteIds = idArr
			}
		},
		onSettingTabClick(tab) {
			this.setting.settingActivetab = tab.name
		},
		getCodeVersion(codes, cb, errCb) {
			const params = {
				results_per_page: Utils.config.maxPageSize,
				q: {
					filters: [
						{
							name: 'code',
							op: 'in',
							val: codes,
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CODE_VERSION, params).then(
				(res) => {
					cb(res.objects)
				},
				() => {
					errCb()
				},
			)
		},
		// 获取在线用户列表
		getNetworkConnects() {
			this.loading = true
			const params = {
				page_size: Utils.config.maxPageSize,
				q_network_id: this.$route.params.id,
			}
			return new Promise((resolve, reject) => {
				this.$store.dispatch(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, params).then((res) => {
					if (res) {
						this.currentConnectList = Object.clone(res)
						resolve(res)
					}
				})
			})
		},
		// 更新管控节点
		updateAgent() {
			let version = Utility.Utils.getAgentVersion(this.newAgentVersion)
			if (version === Utility.Utils.getAgentVersion(this.detail.info.agent.version) && !Utility.Utils.isNeedUpdate(this.detail.info.agent.version, this.newAgentVersion)) {
				this.$notify({
					message: this.$gettext('Already latest version.'),
					type: 'success',
				})
			} else {
				this.getNetworkConnects().then((conns) => {
					if (conns.length) {
						let codes = this.currentConnectList.map('tunnel_code')
						console.log('codes', codes)
						this.getCodeVersion(
							codes,
							(res) => {
								console.log('res', res)
								if (res.length) {
									let networkExist = false
									let clusterCode = []
									res.forEach((item, index) => {
										console.log('id', this.$route.params.id)
										if (item.resource && item.resource.network_id === parseInt(this.$route.params.id)) {
											networkExist = true
											clusterCode.push(item.code)
										}
									})
									if (networkExist) {
										let cloneList = Object.clone(this.currentConnectList)
										let cutIds = []
										this.currentConnectList.forEach((item) => {
											if (clusterCode.indexOf(item.tunnel_code) > -1) {
												cutIds.push(item.id)
												cloneList.remove(item)
												console.log('copy-----', cutIds)
											}
										})
										this.$confirm(this.getTrannum(cutIds.length), this.$gettext('Please confirm'), {
											confirmButtonText: this.$gettext('Disconnect all connections '),
											cancelButtonText: this.$gettext('Upgrade later'),
										}).then(() => {
											// 批量断开在线连接
											this.batchDeleteOnlineUser(cutIds, () => {
												console.log('集群=====')
												// 更新在线列表 store
												this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, cloneList)
												let copyCount = Object.clone(this.$store.getters.dashboard.onlineMembersCount)
												this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - cutIds.length)
												this.onlineConnectTooltip = false
												if (Utility.Utils.getAgentVersion(this.detail.info.agent.version) > '3.0.0') {
													this.detail.agentUpdate = false
												}
											})
											this.noOnlineUserTip('isLowerVersion')
										})
										this.detail.updateTip = false
										this.onlineConnectTooltip = true
									} else {
										console.log('newwork false')
										this.noOnlineUserTip()
										this.detail.updateTip = false
										this.onlineConnectTooltip = false
									}
								} else {
									this.noOnlineUserTip()
									this.detail.updateTip = false
									this.onlineConnectTooltip = false
								}
							},
							() => {
								this.detail.agentUpdate = false
							},
						)
					} else {
						this.noOnlineUserTip()
						this.detail.updateTip = false
					}
				})
			}
			this.detail.backAgent = false
		},
		// 回退管控节点
		backAgent() {
			let nextIndex = 0
			this.refresh.forEach((item, index) => {
				if (this.newAgentVersion == item.version) {
					nextIndex = index + 1
				}
			})
			let backAgentVersion = this.refresh[nextIndex].version
			let version = Utility.Utils.getBackAgentVersion(backAgentVersion)
			let backAgentSha = this.refresh[nextIndex].agent_sha || ''

			// this.setting.backAgentCode = 'bash -c "$(curl -fsSL ' + baseUrl.backAgentUrl + '/install-' + version + '.sh)"' + ' - --upgrade 1' + ' --csos-host ' + baseUrl.csosHost
			this.setting.backAgentCode = `bash -c "$(curl -fsSL ${baseUrl.backAgentUrl}/install-${version}.sh)" - --upgrade 1 --csos-host ${baseUrl.csosHost}`
			this.detail.backAgent = true
			this.detail.agentUpdate = true
		},
		// 没有在线用户版本的更新提示
		noOnlineUserTip(isLowerVersion) {
			console.log('isLowerVersion', isLowerVersion)
			let version = Utility.Utils.getAgentVersion(this.newAgentVersion)
			if (Utility.Utils.getAgentVersion(this.detail.info.agent.version) < '3.0.0') {
				if (!isLowerVersion) {
					this.$notify({
						message: this.$gettext('Please Uninstall Agent Before!'),
						type: 'warning',
					})
				}
			} else if (Utility.Utils.isNeedUpdate(this.detail.info.agent.version, this.newAgentVersion)) {
				this.$notify({
					message: this.$gettext('Not Latest version, you can run script below again to update.'),
					type: 'warning',
				})
				this.detail.agentUpdate = false
			}
		},
		// 批量删除在线用户
		batchDeleteOnlineUser(ids, cd) {
			let params = {
				connection_ids: ids,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.BAECH_DELETE_ONLINE_USER, params).then((res) => {
				cd()
				if (Utility.Utils.getAgentVersion(this.detail.info.agent.version) < '3.0.0') {
					this.$notify({
						message: this.$gettext('Disconnect successfully! Please Uninstall Agent Before!'),
						type: 'warning',
					})
				} else {
					this.$notify({
						type: 'success',
						message: this.$gettext('Disconnect successfully! you can run script below again to update.'),
					})
				}
			})
		},
		getTrannum(num) {
			let translated = this.$ngettext('The current control node has %{ n } online connection. Please disconnect all connections and update it', 'The current control node has %{ n } online connections. Please disconnect all connections and update it', num)
			let interpolated = this.$gettextInterpolate(translated, { n: num })
			return interpolated
		},
		// 解绑管控节点
		unBindAgent() {
			// 解绑管控节点前需判断在线连接有无该集群的连接，有则提示用户断开连接否则无法解绑
			this.getNetworkConnects().then((conns) => {
				if (conns.length) {
					let codes = this.currentConnectList.map('tunnel_code')
					this.getCodeVersion(
						codes,
						(res) => {
							console.log('res:::', res)
							if (res.length) {
								let networkExist = false
								res.forEach((item, index) => {
									console.log('id', this.$route.params.id)
									if (item.resource && item.resource.network_id === parseInt(this.$route.params.id)) {
										networkExist = true
									}
								})
								if (networkExist) {
									this.onlineConnectTooltip = true
								} else {
									this.onlineConnectTooltip = false
									this.unBindAgentApi()
								}
							}
						},
						() => {},
					)
				} else {
					this.unBindAgentApi()
				}
			})
		},
		unBindAgentApi() {
			// 解绑管控节点
			this.$confirm(this.$gettext('Are you sure to uninstall this agent?'), this.$gettext('Uninstall Agent Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				let params = {
					id: this.$route.params.id,
					data: {
						agent_id: null,
					},
				}
				this.$store.dispatch(STORE_CONST.CLUSTER.CHANGE, params).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('unBind successfully!'),
					})
					this.getDetailInfo()
				})
			})
		},
		// 复制文本
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
		},
		// 获取分享集群列表
		getSharingList() {
			this.loading = true
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_SHARING, this.$route.params.id).then(
				(res) => {
					this.loading = false
					this.setting.shareList = this.$store.getters.cluster.detail.settings.shares
				},
				() => {
					this.loading = true
				},
			)
		},
		// 取消分享集群
		delShareCluster(id) {
			this.$confirm(this.$gettext('Are you sure to cancel this sharing?'), this.$gettext('Cancel Share Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					this.$store.dispatch(STORE_CONST.CLUSTER.CANCEL_SHARE, id).then((res) => {
						this.getSharingList()
						this.$notify({
							type: 'success',
							message: this.$gettext('Cancel Share successfully!'),
						})
					})
				})
				.catch(() => {})
		},
		// 删除某一日志过滤
		delLogFilter(id) {
			this.$confirm(this.$gettext('Are you sure to delete this Filters Operation ?'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					this.$store.dispatch(STORE_CONST.CLUSTER.DEL_LOG_FILTER, id).then((res) => {
						this.getDetailInfo()
						this.$notify({
							type: 'success',
							message: this.$gettext('Delete successfully!'),
						})
					})
				})
				.catch(() => {})
		},
		// 批量删除日志过滤
		batchDelLogFilter() {
			this.$confirm(this.$gettext('Are you sure to delete selected resource?'), this.$gettext('Delete Resource Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					let ids = this.setting.logBatchIds
					this.$store.dispatch(STORE_CONST.CLUSTER.DEL_BARCH_LOG_FILTER, ids).then((res) => {
						this.getDetailInfo()
						this.$notify({
							type: 'success',
							message: this.$gettext('Delete successfully!'),
						})
					})
				})
				.catch(() => {})
		},
		// 过滤日志批量删除的选中
		onSelectLog(v) {
			if (v.length !== 0) {
				this.setting.logBatchIds = v.map((item) => item.id).join(',')
			} else {
				this.setting.logBatchIds = ''
			}
			console.log('log', this.setting.logBatchIds)
		},
		// 添加主机和数据库
		onAdd() {
			if (this.$route.query.type === 'ecs') {
				this.onShowClusterAddInstance()
				console.log('ecs')
			} else if (this.$route.query.type === 'rds') {
				console.log('rds')
				this.onShowClusterAddDatabase()
			}
		},
		// 设置中添加分享集群和日志
		onSettingAdd() {
			if (this.setting.activeTab === 'shareCluster') {
				this.onShowClusterAddShare()
			} else if (this.setting.activeTab === 'logFilter') {
				this.onShowClusterLogFilter()
			}
		},
		// 主机和数据库中的设置
		onSetting(id) {
			if (this.$route.query.type === 'ecs') {
				console.log('ecs')
				this.onShowClusterInstanceSetting(id)
			} else if (this.$route.query.type === 'rds') {
				console.log('rds')
				this.onShowClusterDatabaseSetting(id)
			}
		},
		// 测试连通性
		onTestConnection(resource) {
			let params = {
				resource_id: resource.id,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.TEST_CONNECTION, params).then((res) => {
				this.detail.taskId = res.task_id
				resource.taskId = res.task_id
				console.log('resource--->测试', resource)
				this.queryTest(resource)
			})
		},
		// 轮循测试连通性
		queryTest(resource) {
			let params = {
				task_id: resource.taskId,
			}
			console.log('query------>轮询', resource)
			this.$store.dispatch(STORE_CONST.CLUSTER.QUERY_TEST, params).then((res) => {
				if (res.result == null || !res.result) {
					this.$set(
						this.detail.list,
						this.detail.list.indexOf(resource),
						Object.assign(resource, {
							test_result: 'disable',
						}),
					)
				} else {
					this.$set(
						this.detail.list,
						this.detail.list.indexOf(resource),
						Object.assign(resource, {
							test_result: res.result,
						}),
					)
					if (res.result === 'pending') {
						setTimeout(() => {
							this.queryTest(resource)
						}, 3000)
					} else {
					}
				}
			})
		},
		// 提交设置中第三方AKform表单
		/* onSubmitUnableForm() {
			this.setting.unavailable.disCheck = true
			this.setting.isUpdateCode = true
			this.setting.unavailable.code = 'bash -c "$(curl -fsSL ' + baseUrl.agentInstallUrl + ')" - --key ' + this.detail.info.key + ' --sshproxyport 9998 --websshport 8889 --mysqlproxyport 9696 --rdpagentport 9389 --mssqlproxyport 9433 --AccessKeyId ' + this.unavailableForm.keyId + ' --AccessKeySecret ' + this.unavailableForm.keySecret + ' --RegionId ' + this.unavailableForm.region + ' --self-host default'
		}, */
		// search
		onSearch() {
			this.tableHeader.filters = []
			if (this.tableHeader.searchForm.type !== '') {
				this.tableHeader.filters.push({
					name: 'extension',
					op: 'like',
					val: '%' + this.tableHeader.searchForm.type + '%',
				})
			}
			if (this.tableHeader.searchForm.text !== '') {
				this.tableHeader.filters.push({
					name: this.tableHeader.searchForm.condition,
					op: 'like',
					val: '%' + this.tableHeader.searchForm.text + '%',
				})
			}
			this.getDetailList(1, this.detail.info.default_project_id)
		},
		// 分页
		onChangePage(page) {
			this.getDetailList(page, this.detail.info.default_project_id)
		},
		// 切换tab
		onTabClick(tab) {
			this.$router.push({ name: 'clusterDetail', query: { type: tab.name } })
			this.tableHeader.filters = []
			this.tableHeader.searchForm = {
				type: '',
				condition: '',
				text: '',
			}
		},
		changeCurrentTab(tab, defaultProjectId) {
			this.detail.currentTab = this.$route.query.type || 'ecs'
			if (tab === 'settings') {
				this.detail.info.parent_id ? (this.setting.activeTab = 'logFilter') : (this.setting.activeTab = 'shareCluster')
				this.getSharingList()
			} else {
				if (defaultProjectId) {
					this.getDetailList(1, defaultProjectId)
				}
			}
		},
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},
		// key 上传
		onUpload(option) {
			this.upload = Object.assign({}, this.upload, {
				isUpload: option.isUpload,
				username: option.username,
				resourceId: option.resourceId,
				password: '',
			})
			console.log('username', this.upload.resourceId, this.upload.isUpload)
		},
		// 确定上传 sshkey
		onComfirmUpload() {
			let params = {
				resourceId: this.upload.resourceId,
				data: {
					password: this.upload.password,
					username: this.upload.username,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.UOLOAD_SSHKEY, params).then((res) => {
				let id = res.task_id
				this.queryUpload(id)
			})
		},
		// 上传sshkey轮询
		queryUpload(id) {
			let queryParams = {
				resourceId: this.upload.resourceId,
				params: {
					task_id: id,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.QUERY_SSHKEY, queryParams).then((res) => {
				this.upload.status = res.result
				this.upload.password = ''
				if (res.result !== 'pending') {
					if (res.result === 'failed') {
						this.$notify({
							type: 'error',
							message: this.$gettext('Upload failed'),
						})
					} else {
						this.$notify({
							type: 'success',
							message: this.$gettext('Upload success'),
						})
						this.upload.isUpload = false
					}
				} else {
					setTimeout(() => {
						this.queryUpload(id)
					}, 1000)
				}
			})
		},
		// 关闭侧滑回调
		onClosePanel() {
			console.log('this.currentRightPanel.name', this.currentRightPanel.name)
			if (this.currentRightPanel.name === 'ClusterSafeMode') {
				setTimeout(() => {
					this.getDetailInfo()
				}, 300)
			}
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		// 侧滑回调函数
		callback() {
			console.log('callback===', this.currentRightPanel.name)
			if (this.currentRightPanel.name === 'ClusterSafeMode' || this.currentRightPanel.name === 'ClusterLogFilter' || this.currentRightPanel.name === 'ChangeClusterName' || this.currentRightPanel.name === 'SetCluster') {
				return this.getDetailInfo()
			} else if (this.currentRightPanel.name === 'ClusterAddShare') {
				return this.getSharingList()
			} else {
				return this.getDetailList(this.detail.currentPage, this.detail.info.default_project_id)
			}
		},
		// 显示修改安全模式
		onShowClusterSafeMode() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterSafeMode' ? 0 : 300
			this.currentRightPanel = ClusterSafeMode
			this.$nextTick(() => {
				setTimeout(() => {
					console.log('click', this.detail.info)
					this.rightPanelData = Object.clone(this.detail.info)
				}, time)
			})
		},
		// 显示主机中的添加
		onShowClusterAddInstance() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddInstance' ? 0 : 300
			this.currentRightPanel = ClusterAddInstance
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		// 显示批量导入
		onShowClusterBatchInstance() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterBatchInstance' ? 0 : 300
			this.currentRightPanel = ClusterBatchInstance
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		// 显示扫描导入
		onShowClusterScanImport() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterScanImport' ? 0 : 300
			this.currentRightPanel = ClusterScanImport
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = Object.clone(this.detail.info)
				}, time)
			})
		},
		// AK导入
		onShowClusterAkImport() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAkImport' ? 0 : 300
			this.currentRightPanel = ClusterAkImport
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = Object.clone(this.detail.info)
				}, time)
			})
		},
		// 显示主机设置
		onShowClusterInstanceSetting(id) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterInstanceSetting' ? 0 : 300
			this.currentRightPanel = ClusterInstanceSetting
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = id
				}, time)
			})
		},
		// 显示数据库添加
		onShowClusterAddDatabase() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddDatabase' ? 0 : 300
			this.currentRightPanel = ClusterAddDatabase
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						supportMutipleDatabase: this.supportMutipleDatabase,
					}
					// this.rightPanelData = []
				}, time)
			})
		},
		// 显示数据库设置
		onShowClusterDatabaseSetting(id) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterDatabaseSetting' ? 0 : 300
			this.currentRightPanel = ClusterDatabaseSetting
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = id
				}, time)
			})
		},
		// 显示添加分享集群
		onShowClusterAddShare() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddShare' ? 0 : 300
			this.currentRightPanel = ClusterAddShare
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						domain: {
							label: this.$gettext('Team code'),
							val: '',
							rule: [
								{ required: true, message: this.$gettext('Please input the team code'), trigger: 'blur' },
								{ validator: this.trimSapce, trigger: 'blur' },
							],
						},
					}
				}, time)
			})
		},
		trimSapce(rule, value, callback) {
			console.log('rule', rule, value)
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === ClusterLogFilter) {
					callback(new Error(this.$gettext('Please input the condition')))
				} else if (this.currentRightPanel === ClusterAddShare) {
					callback(new Error(this.$gettext('Please input the team code')))
				}
			} else {
				value = value.trim()
				callback()
			}
		},
		// 显示添加日志过滤
		onShowClusterLogFilter() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterLogFilter' ? 0 : 300
			this.currentRightPanel = ClusterLogFilter
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						filterOperator: {
							label: this.$gettext('Fileter Operator'),
							val: 'contains',
							disabled: 'disabled',
							rule: [{ message: this.$gettext('Please input the condition'), trigger: 'blur' }],
						},
						condition: {
							label: this.$gettext('Condition'),
							val: '',
							rule: [
								{ required: true, message: this.$gettext('Please input the condition'), trigger: 'blur' },
								{ validator: this.trimSapce, trigger: 'blur' },
							],
						},
					}
				}, time)
			})
		},
		// 查看支持镜像
		onShowClusterCheckSupport() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterCheckSupport' ? 0 : 300
			this.currentRightPanel = ClusterCheckSupport
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		// 显示Linux 云ak
		onCloudShow(option) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterCloudAk' ? 0 : 300
			this.currentRightPanel = ClusterCloudAk
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = option
				}, time)
			})
		},
		// 显示cloud dialog
		onShowCloudDialog(option) {
			this.cluodDialog.Instances = option.Instances
			this.cluodDialog.resourceId = option.resourceId
			if (option.type === 1) {
				if (option.Instances && option.Instances.InstanceId) {
					if (option.Instances.Status === 'Stopped') {
						this.cluodDialog.start = true
					}
				}
			} else if (option.type === 2) {
				this.cluodDialog.reStart = true
			} else if (option.type === 3) {
				this.cluodDialog.stopInstance = true
			}
		},
		onOpenStop() {
			this.cluodDialog.stopWay = '1'
			this.cluodDialog.isForceShop = false
		},
		onOpenRestart() {
			this.cluodDialog.reStartWay = '1'
			this.cluodDialog.isForcereStart = false
		},
		onStart() {
			this.cluodDialog.start = false
			let params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'StartInstance',
				},
			}
			this.$refs['rightComponent'].changeStatus('Starting')
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then((d) => {
				this.$refs['rightComponent'].loadInstanceStatus()
			})
		},
		onStop() {
			let params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'StopInstance',
					ForceStop: this.cluodDialog.isForceShop,
				},
			}
			this.$refs['rightComponent'].changeStatus('Stopping')
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then((d) => {
				this.$refs['rightComponent'].loadInstanceStatus()
				this.cluodDialog.isForceShop = false
				this.cluodDialog.stopInstance = false
			})
		},
		onRestart() {
			this.$refs['rightComponent'].changeStatus('Stopping')
			let params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'RebootInstance',
					ForceStop: this.cluodDialog.isForcereStart,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_ALIYUN_ECS, params).then((d) => {
				this.$refs['rightComponent'].loadInstanceStatus()
				this.cluodDialog.reStart = false
			})
		},
		// 关闭更新管控节点提示
		closeUpdateTip() {
			this.detail.updateTip = false
			console.log('close=====>')
		},
	},
	beforeRouteLeave(to, from, next) {
		console.log('leave route')
		clearInterval(this.intervalId)
		next()
	},
	watch: {
		unavailableForm: {
			handler: function (newVal, oldVal) {
				this.$refs['unavailableForm'].validate((valid) => {
					this.unavailableForm.isCanSubmit = valid
				})
			},
			deep: true,
		},
		$route(to, from) {
			this.detail.currentTab = this.$route.query.type
			this.changeCurrentTab(this.detail.currentTab, this.detail.info.default_project_id)
		},
	},
	components: {
		ElButton,
		ClusterSafeMode,
		ClusterAddInstance,
		ClusterBatchInstance,
		ClusterScanImport,
		ClusterAkImport,
		ClusterInstanceSetting,
		ClusterAddDatabase,
		ClusterDatabaseSetting,
		ClusterAddShare,
		ClusterLogFilter,
		ClusterCheckSupport,
		ClusterCloudAk,
		ChangeCluster,
		SetCluster,
		ClusterConfigFile,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.cluster-detail {
	.font-danger {
		color: red;
		padding-bottom: 5px;
	}
	.view-title-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title-left {
			flex: 1;
		}
	}
	.disable-btn {
		color: #bfcbd9;
		cursor: not-allowed;
		background-image: none;
		background-color: #eef1f6;
		border-color: #d1dbe5;
	}
	.instance-dialog {
		.dialog-content {
			.agent-version {
				padding-left: 30%;
				margin-top: 30px;
				.sub-title {
					display: inline-block;
					width: 100px;
					text-align: right;
				}
				.version {
					margin-left: 30px;
				}
			}
			.tip {
				color: $textColor;
			}
			.instance-id {
				margin: 10px 0;
			}
			.el-radio + .el-radio {
				display: block;
				margin-top: 10px;
			}
			.force-stop {
				margin-top: 20px;
				padding: 10px 20px;
				border-radius: 5px;
				background-color: #fcf8e3;
				.tip {
					margin-bottom: 10px;
				}
			}
		}
	}
	.dialog {
		.el-dialog--small {
			width: 500px;
		}
		.dialog-content {
			padding-left: 40px;
			.el-input {
				width: 300px;
				margin-left: 30px;
			}
			p {
				margin-left: 80px;
				margin-top: 5px;
			}
		}
	}
	.badge {
		padding: 2px;
		margin-left: 3px;
		font-size: 10px;
		color: #fff;
		&.available {
			background-color: $available;
		}
		&.unavailable {
			background-color: $unavailable;
		}
	}
	.del-btn {
		float: right;
		margin-left: 20px;
	}
	.ssk-wrapper {
		.add-ssk {
			height: 60px;
			line-height: 60px;
			padding: 0 15px;
			background-color: #fff;
			border: 1px solid $border-color;
			border-bottom: none;
			.el-button--text {
				color: $textColor;
				&:hover {
					color: $mainColor;
				}
				&.is-disabled {
					color: $textColor;
				}
			}
			.change-btn {
				color: $mainColor;
				margin-left: 5px;
			}
			.pull-right {
				.el-input__inner {
					border-radius: 0;
					height: 32px;
				}
				.account-search {
					width: 100px;
					.el-input__icon {
						font-size: 10px;
						width: 21px;
					}
					.el-input__inner {
						padding-right: 21px;
					}
				}
				.condition-search {
					width: 80px;
					.el-input__icon {
						font-size: 10px;
						width: 21px;
					}
					.el-input__icon + .el-input__inner {
						padding-right: 20px;
						border-right: none;
					}
				}
				.searchInput {
					width: 180px;
				}
			}
		}
		/*settingTab style*/
		.setting-wrapper {
			background-color: #fff;
			padding: 10px 20px;
			border: 1px solid $border-color;
			.copy-text {
				display: inline-block;
				margin: 10px 0;
				padding: 5px 15px;
				border: 1px solid #4084ff;
				background-color: #e7f0ff;
				color: #4084ff;
				font-size: 12px;
				.code {
					line-height: 20px;
				}
				.el-col {
					padding: 8px 0;
				}
				.el-button--text {
					text-align: right;
					padding: 4px 30px;
				}
			}
		}
		.tips {
			margin-bottom: 10px;
			p {
				margin-top: 5px;
			}
		}
		.general {
			/*margin-top: 5px;*/
			.m-space {
				margin-right: 10px;
			}
			.bold {
				font-weight: 700;
			}
		}
		.agent-wrapper {
			margin-top: 10px;
		}
		.unavailable-form {
			margin-bottom: 10px;
			padding: 10px 15px;
			border: 1px solid $border-color;
			background-color: #fff;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			.unavailable-select {
				width: 300px;
			}
			.unable-tip {
				line-height: 30px;
				color: red;
			}
			.set-btn {
				padding: 10px 25px;
				margin-left: 160px;
			}
			.tip-text {
				line-height: 1;
				margin-top: 5px;
			}
		}
		.setting-tab {
			.el-tabs__header {
				background-color: #eff3f4;
				padding: 0;
				margin: 0;
			}
			.el-tabs__content {
				padding: 0 0 20px;
			}
		}
		.setting-header {
			padding-left: 10px;
			line-height: 30px;
			background-color: #fff;
			border-left: 1px solid $border-color;
			border-right: 1px solid $border-color;
			font-size: 12px;
		}
	}
	.el-input__inner {
		width: 100%;
	}
	.el-table-column--selection .cell {
		padding-left: 11px;
		padding-right: 14px;
	}
	.el-table_1_column_1 {
		padding-left: 10px;
	}
	.table-wrapper {
		padding: 0 20px;
		.open-key {
			color: $mainColor;
			&:hover {
				cursor: pointer;
			}
		}
		.item {
			color: $available;
		}
		.text-warning {
			color: $unavailable;
		}
	}
	.truncate {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
</style>



// WEBPACK FOOTER //
// cluster-detail.vue?f70b0fca